var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import classNames from "classnames";
import React, { forwardRef, useCallback } from "react";
import { WithIcon } from "../_primitives/WithIcon.js";
const QuiTagDeleteButton = ({ onClick, disabled, size }) => {
    return (React.createElement("i", { role: "button", className: `qui-icon qui-icon-x qui-interactive ${disabled ? "qui-disabled" : ""} qui-size-${size}`, onClick: onClick }));
};
export const QuiTag = forwardRef((_a, ref) => {
    var { iconLeft, iconRight, children, size, variant, disabled, className, onClick, onRemove } = _a, otherProps = __rest(_a, ["iconLeft", "iconRight", "children", "size", "variant", "disabled", "className", "onClick", "onRemove"]);
    const tagSize = size !== null && size !== void 0 ? size : "md";
    const isInteractive = !!onClick;
    const isRemovable = !!onRemove;
    const cssClasses = classNames(className, getCssClasses(tagSize, isInteractive, disabled !== null && disabled !== void 0 ? disabled : false, variant));
    const handleDelete = useCallback((e) => {
        if (disabled)
            return;
        // stop progagation to prevent our main tag onClick from firing when the remove button is clicked
        e.stopPropagation();
        if (onRemove) {
            onRemove(e);
        }
    }, [onRemove, disabled]);
    const onTagClick = useCallback((e) => !disabled && onClick && onClick(e), [onClick, disabled]);
    return (React.createElement("div", Object.assign({ className: cssClasses, onClick: onTagClick, tabIndex: 0, role: isInteractive ? "button" : undefined, ref: ref }, otherProps),
        React.createElement(WithIcon, { iconLeft: iconLeft, iconRight: isRemovable ? () => React.createElement(QuiTagDeleteButton, { size: tagSize, disabled: disabled !== null && disabled !== void 0 ? disabled : false, onClick: handleDelete }) : iconRight, iconSize: tagSize === "md" ? "md" : "xs" }, children)));
});
QuiTag.displayName = "QuiTag";
function getCssClasses(size, interactive, disabled, variant) {
    return classNames("qui-tag", "qui-text-sm", "qui-flex-inline-xs", "qui-align-center", "qui-inset-xs-md", "qui-radius-xl", `qui-tag-${size}`, {
        "qui-interactive": interactive,
        [`qui-tag-${variant}`]: variant,
        "qui-disabled": disabled,
    });
}
